// Liste fixe des thèmes de vidéo, alignée sur la table `themes` en base
// (supabase/sql/001_feed_schema.sql). Toute modification doit être faite dans
// les deux endroits.

export const THEME_IDS = [
  'gaming',
  'tech',
  'sport',
  'music',
  'food',
  'beauty',
  'comedy',
  'news',
  'finance',
  'lifestyle',
  'entertainment',
  'other',
] as const;

export type ThemeId = (typeof THEME_IDS)[number];

/**
 * Thèmes proposés dans les listes. « Autre » en est exclu : c'est la valeur par
 * défaut en base, portée par les lots publiés avant l'arrivée des thèmes. On
 * garde l'identifiant valide pour pouvoir les étiqueter, mais on ne le propose
 * plus — ces lots restent atteignables depuis l'Accueil, qui ignore les thèmes.
 */
export const SELECTABLE_THEME_IDS = THEME_IDS.filter(id => id !== 'other');

export const isThemeId = (value: string): value is ThemeId =>
  (THEME_IDS as readonly string[]).includes(value);
